<template>
  <div class="auth-page">
    <UcariHeader />
    <main class="system-page"><section class="system-card">
      <span class="system-card__icon system-card__icon--success" uk-icon="icon: check; ratio: 1.5"></span>
      <span class="eyebrow">Verified</span>
      <h1>Your email is verified</h1>
      <p>Your partner account email has been confirmed. You can now sign in.</p>
      <router-link to="/login" class="uk-button uk-button-primary">Sign in</router-link>
    </section></main>
    <RetailerFooter />
  </div>
</template>

<script>
import UcariHeader from './components/UcariHeader.vue';
import RetailerFooter from './components/RetailerFooter.vue';
export default {
  components: { UcariHeader, RetailerFooter },
  created() {
    document.title = "Email Verified | UCARI";
  },
};
</script>
